export default __webpack_public_path__ + "static/media/Logo15Years.ba58c0e7.svg";